import { createGlobalStyle } from "styled-components"
import { colors } from "./cssVariables"

export default createGlobalStyle`
  body {
    font-family: 'SF UI Text';
    color: ${colors.lightGray};
  }
`
